import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

import { styles as flexBoxHelpersStyles } from '../../../assets/flexbox-helpers.scss';

export const templateLicenseMonthlySubscriptionSubForm = document.createElement('template');

templateLicenseMonthlySubscriptionSubForm.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexBoxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-accordion class='license-form-section mt-2' id='subscription-details-section' isOpen isCompact>
      <section class='subform-section'>
        <gz-text class='subform-section-label mt-2 mb-1' fontSize="14" id='subscription-preferences-label'></gz-text>
        <div class='subform-section-fields'>
          <gz-form-field-toggleable class='toggle-field label-mw-250' id='reserve-seats-form-field'>
            <div class='d-flex align-items-center'>
              <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
              <gz-text class='ml-1 hidden' fontSize='13' id='available-seats-text'></gz-text>
            </div>
            <gz-input-error></gz-input-error>
          </gz-form-field-toggleable>

          <section class='text-form-field-section'>
            <gz-form-field-toggleable class='toggle-field label-mw-250' id='add-subscription-end-date-form-field'>
              <div class='d-flex products-and-service-section'>
                <gz-date-picker gz-form-input placeholder=''></gz-date-picker>
              </div>
              <gz-input-error></gz-input-error>
            </gz-form-field-toggleable>

            <gz-text fontSize="12" class="mb-1" id="add-subscription-end-date-text"></gz-text>
          </section>

          <section class='text-form-field-section'>
            <gz-form-field-toggleable class='toggle-field label-mw-250' id='set-auto-renewal-form-field' disabled>
              <div class='d-flex'>
                <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
              </div>
              <gz-input-error></gz-input-error>
            </gz-form-field-toggleable>

            <gz-text fontSize="12" class="mb-1" id="set-auto-renewal-text"></gz-text>
          </section>

          <section class='text-form-field-section'>
            <gz-form-field-toggleable class='toggle-field label-mw-250' id='minimum-usage-form-field'>
              <div class='d-flex'>
                <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
              </div>
              <gz-input-error></gz-input-error>
            </gz-form-field-toggleable>

            <gz-text fontSize="12" class="mb-1" id="minimum-usage-text"></gz-text>
          </section>
        </div>
      </section>
    </gz-accordion>


    <section class='subform-section'>
      <gz-accordion class='license-form-section' id='own-use-section' isCompact>
        <section title=''>
          <section id='own-use-product-details'>
            <span class='subtitle'>
              <span id='own-use-product-details-endpoint-security-text'></span>
              <gz-link type='underline' color='primary' id='own-use-product-details-endpoint-security-link'></gz-link>
            </span>
            <span class='subtitle'>
              <span id='own-use-product-details-bitdefender-edr-text'></span>
              <gz-link type='underline' color='primary' id='own-use-product-details-bitdefender-edr-link'></gz-link>
            </span>
          </section>

          <gz-form-field id='own-use-product-type-form-field' class='label-mw-250' required>
            <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <section class='subform-section' id='own-use-bundles-section' class='hidden'>
            <gz-text fontSize="14" class='bundle_section_title' id='own-use-bundle-title'></gz-text>
            <gz-license-monthly-bundle-form id='own-use-bundle-form'></gz-license-monthly-bundle-form>
          </section>

          <section class='subform-section pl-2' id='own-use-addons-section' class='hidden'>
            <gz-title fontSize='11' fontWeight='600' class='title' id='own-use-addons-label'></gz-title>

            <span class='subtitle' id='own-use-addons-details'>
              <span id='own-use-addons-details-text'></span>
              <br>
              <gz-link type='underline' color='primary' id='own-use-addons-details-link'></gz-link>
            </span>

            <section class='d-flex products-and-service-section pl-2 mt-1'>
              <div class='subform-section-fields'>
                <gz-license-monthly-addons-form id='own-use-addons-form'></gz-license-monthly-addons-form>
              </div>
            </section>
          </section>

          <section class='subform-section pl-2' id='own-use-services-section' class='hidden'>
            <gz-title fontSize='11' fontWeight='600' class='title' id='own-use-services-label'></gz-title>

            <span class='subtitle' id='own-use-services-details'>
              <span id='own-use-services-details-text'></span>
              <br>
              <gz-link type='underline' color='primary' id='own-use-services-details-link'></gz-link>
            </span>

            <section class='d-flex products-and-service-section pl-2 mt-1'>
              <div class='subform-section-fields'>
                <gz-license-monthly-services-form id='own-use-services-form'></gz-license-monthly-services-form>
              </div>
            </section>
          </section>
        </section>
      </gz-accordion>
    </section>

    <section class='subform-section'>
      <gz-accordion class='license-form-section' id='reselling-section' isCompact>
        <section title=''>
          <section class='subform-section' id='reselling-product-section'>
            <p class='subtitle' id='reselling-product-type-details'></p>

            <span class='subtitle'>
              <span id='reselling-product-details-endpoint-security-text'></span>
              <gz-link type='underline' color='primary' id='reselling-product-details-endpoint-security-link'></gz-link>
            </span>
            <span class='subtitle'>
              <span id='reselling-product-details-bitdefender-edr-text'></span>
              <gz-link type='underline' color='primary' id='reselling-product-details-bitdefender-edr-link'></gz-link>
            </span>

            <section class='d-flex products-and-service-section'>
              <p class='subform-section-label mr-0 mt-3' id='reselling-product-type-label'></p>

              <div class='subform-section-fields mt-2'>
                <gz-form-field class='toggle-field' id='reselling-product-es-toggle-form-field'>
                  <gz-toggle gz-form-input placeholder=''></gz-toggle>
                </gz-form-field>

                <gz-form-field class='toggle-field' id='reselling-product-edr-toggle-form-field'>
                  <gz-toggle gz-form-input placeholder=''></gz-toggle>
                </gz-form-field>
              </div>
            </section>
          </section>

          <section class='subform-section' id='reselling-bundles-section' class='hidden'>
            <gz-title class='bundle_section_title' fontSize="14" id='resell-bundle-title'></gz-title>
            <gz-license-monthly-resell-bundle-form id='resell-use-bundle-form'></gz-license-monthly-resell-bundle-form>
          </section>

          <section class='subform-section pl-2' id='reselling-addons-section' class='hidden'>
            <gz-title fontSize='11' fontWeight='600' class='title' id='reselling-addons-label'></gz-title>

            <span class='subtitle' id='reselling-addons-details'>
              <span id='reselling-addons-details-text'></span>
              <br>
              <gz-link type='underline' color='primary' id='reselling-addons-details-link'></gz-link>
            </span>

            <section class='d-flex products-and-service-section pl-2 mt-1'>
              <div class='subform-section-fields'>
                <gz-license-monthly-addons-form id='reselling-addons-form'></gz-license-monthly-addons-form>
              </div>
            </section>
          </section>

          <section class='subform-section pl-2' id='reselling-services-section' class='hidden'>
            <gz-title fontSize='11' fontWeight='600' class='title' id='reselling-mdr-services-label'></gz-title>

            <span class='subtitle' id='reselling-services-details'>
              <span id='reselling-services-details-text'></span>
              <br>
              <gz-link type='underline' color='primary' id='reselling-services-details-link'></gz-link>
            </span>

            <section class='d-flex products-and-service-section pl-2 mt-1'>
              <section class='tooltip-form-field-section' id='reselling-mdr-services-section'>
                <gz-form-field id='reselling-mdr-services-form-field'>
                  <gz-toggle gz-form-input placeholder=''></gz-toggle>
                </gz-form-field>
              </section>
            </div>
          </section>
        </section>
      </gz-accordion>
    </section>
  </div>
`;
